module.exports = __webpack_public_path__ + "static/media/12_guit_a.eaa216ea.ogg";